module.exports = __webpack_public_path__ + "img/1F4F5.a6b788b0.svg";